export const CHARTS = {
	MATRIX: 'MATRIX',
	DONUT: 'DONUT',
	US_MAP: 'US_MAP',
	WORLD_MAP: 'WORLD_MAP',
	EARTH_MAP: 'EARTH_MAP',
	CHOROPLETH_MAP: 'CHOROPLETH_MAP',
	STACKED_BAR: 'STACKED_BAR',
	BAR: 'BAR',
	POLAR_AREA: 'POLAR_AREA',
	CIRCLE_PACK: 'CIRCLE_PACK',
	CUSTOM_CIRCLE_PACK: 'CUSTOM_CIRCLE_PACK',
	HEAT_MAP: 'HEAT_MAP',
	TABLE: 'TABLE',
	TIMELINE: 'TIMELINE',
};

export const LOGO_TYPES = {
	IMAGE: 'IMAGE',
	TEXT: 'TEXT',
};

export type TODO = any;

//TODO move this to middleware
export enum FilterComparatorType {
	Equals = '$eq',
	NotEquals = '$ne',
	LessThan = '$lt',
	LessThanEquals = '$lte',
	GreaterThan = '$gt',
	GreaterThanEquals = '$gte',
	StartsWith = '$sw',
	NotStartsWith = '$nsw',
	EndsWith = '$ew',
	Contains = '$c',
	NotContains = '$nc',
	Token = '$token',
	TokenStartsWith = '$tsw',
	TokenEndsWith = '$tew',
	YoungerThan = '$yt',
	Exists = '$exists',
	Inside = '$inside',
	ElementsMatch = '$elemMatch',
}

//TODO move this to middleware
export enum OperatorType {
	/** Combines all the child operations and condition results with a logical AND */
	And = '$and',
	/** Combines all the child operations and condition results with a logical OR */
	Or = '$or',
	/** Combines all the child operations and condition results with a logical ANDNOT */
	Nand = '$nand',
}
